import { cn } from "@/lib/utils";

export function Logo({ className = "h-12 w-12" }: { className?: string }) {
  return (
    <img
      src="/logo.png"
      alt="Agricos Monitor"
      className={cn("object-contain", className)}
    />
  );
}
